"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.mudarStatus = exports.update = exports.cadastreSe = exports.create = exports.findOne = exports.listaCidades = exports.listaCnpj = exports.findAll = void 0;
const core_1 = require("./core");
const search_1 = require("./search");
function findAll(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('Fornecedor', 'lista', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAll = findAll;
function listaCnpj(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('Fornecedor', 'listaCnpj', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.listaCnpj = listaCnpj;
function listaCidades(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('Fornecedor', 'listaCidades', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.listaCidades = listaCidades;
function findOne(id) {
    return core_1.get('Fornecedor', 'detalhe', { id });
}
exports.findOne = findOne;
function create(data) {
    return core_1.post('Fornecedor', 'cadastro', data);
}
exports.create = create;
function cadastreSe(data) {
    return core_1.post('Fornecedor', 'cadastreSe', data);
}
exports.cadastreSe = cadastreSe;
function update(id, data) {
    return core_1.post('Fornecedor', 'update', Object.assign({ id }, data));
}
exports.update = update;
function mudarStatus(id, data) {
    return core_1.put('Fornecedor', 'mudarStatus', Object.assign({ id }, data));
}
exports.mudarStatus = mudarStatus;
function remove(id) {
    return core_1.del('Fornecedor', 'exclui', { id });
}
exports.remove = remove;
